const sessionStorageClassCodeKey = 'yhj-class-code';

export function getClassCode() {
  try {
    return window.sessionStorage.getItem(sessionStorageClassCodeKey);
  } catch (e) {
    return false;
  }
}

export function setClassCode(code) {
  try {
    window.sessionStorage.setItem(sessionStorageClassCodeKey, code);
  } catch (e) {
    // Error silently
  }
}

export function removeClassCode() {
  try {
    window.sessionStorage.removeItem(sessionStorageClassCodeKey);
  } catch (e) {
    // Error silently
  }
}
